import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPassword } from '../../services/api';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordRetype, setNewPasswordRetype] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get('token');
    if (!t) {
      setStatus('error');
      setMessage('Missing or invalid reset token.');
    } else {
      setToken(t);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== newPasswordRetype) {
      setStatus('error');
      setMessage('Passwords do not match');
      return;
    }
    setStatus('submitting');
    setMessage('');
    try {
      const res = await resetPassword({ token, newPassword, newPasswordRetype });
      setStatus('success');
      setMessage(res.message || 'Password reset successful.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage(err.response?.data?.message || 'Failed to reset password.');
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5">
          <div className="card shadow">
            <div className="card-header bg-conference-gradient text-white text-center">
              <h3 className="mb-0">Reset Password</h3>
            </div>
            <div className="card-body p-4">
              {status === 'success' ? (
                <div className="text-center">
                  <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '3.5rem' }}></i>
                  <h5 className="mt-3 text-success">Success</h5>
                  <p className="text-muted">{message}</p>
                  <p className="small text-muted">Redirecting to login...</p>
                </div>
              ) : status === 'error' && !token ? (
                <div className="alert alert-danger mb-0">{message}</div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      minLength={8}
                      required
                    />
                    <div className="form-text">At least 8 characters.</div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Confirm New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={newPasswordRetype}
                      onChange={(e) => setNewPasswordRetype(e.target.value)}
                      minLength={8}
                      required
                    />
                  </div>
                  {status === 'error' && message && (
                    <div className="alert alert-danger py-2">{message}</div>
                  )}
                  <button
                    type="submit"
                    className="btn btn-conference-primary w-100"
                    disabled={status === 'submitting'}
                  >
                    {status === 'submitting' ? 'Resetting...' : 'Reset Password'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
